enum FlexGridSortingTypeEnum {
    Up = 1,
    Down,
}
export default FlexGridSortingTypeEnum;
